import { OrderChangesHistory } from '../../../../api/services/orders/types.ts'
import { convertToFullDate } from '../../../../utils/formatter.ts'
import Card from '../../../common/Card/Card.tsx'

const Planned = ({ planned }: { planned: OrderChangesHistory[] }) => {
  if (planned.length === 0) {
    return <p className="p-4 text-center">Brak udostępnionych diet.</p>
  }

  return (
    <Card className="w-full box-border mt-8 shadow-md">
      <Card.Body>
        {planned &&
          planned.map((item) => {
            const sent = convertToFullDate(item.planned_share_date) < new Date()
            return (
              <div
                key={item.created_at}
                className={`flex p-1 my-1 gap-2 dark:text-black-2 ${sent ? 'bg-[#87B725] text-white' : 'bg-yellow-100'}`}
              >
                <p className="font-bold">{item.planned_share_date}</p>
                <p>{sent ? 'Wysłana' : 'Zaplanowana'}</p>
              </div>
            )
          })}
      </Card.Body>
    </Card>
  )
}

export default Planned
